/* Product page: tidy long spec lists (2026-10-15).
   Groups "Heading: + list" blocks from the product description into a "Full specifications" panel:
   a tap-to-open section on phones (starts closed), an open two-column card grid on larger screens.
   Intro text and notes (warranty, delivery, "please note") stay visible. Descriptions that don't
   follow the heading + list pattern are left exactly as they are. */

/* The image-zoom plugin adds enlarged copies of the product photo without alt text (mark them decorative),
   and the slider builds its thumbnail strip without alt text (label them "<product> – photo N"). */
(function () {
  var gallery = document.querySelector('.product_gallery');
  if (!gallery || !window.MutationObserver) return;
  var h1 = document.querySelector('.template-product .title h1');
  var name = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : 'Product';
  var mark = function () {
    gallery.querySelectorAll('img.zoomImg:not([alt])').forEach(function (img) { img.setAttribute('alt', ''); });
    gallery.querySelectorAll('.flex-control-thumbs img:not([alt])').forEach(function (img) {
      var li = img.closest('li');
      var n = li && li.parentElement ? Array.prototype.indexOf.call(li.parentElement.children, li) + 1 : 1;
      img.setAttribute('alt', name + ' – photo ' + n);
    });
  };
  mark();
  new MutationObserver(mark).observe(gallery, { childList: true, subtree: true });
})();

(function () {
  var desc = document.querySelector('.template-product .pro_main_c .rte[class*="main-product-description-"]');
  if (!desc || desc.dataset.tspSpecs) return;
  desc.dataset.tspSpecs = '1';

  var LIST = /^(UL|OL|TABLE)$/;
  var HEAD = /^H[2-6]$/;
  var text = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); };
  var isEmpty = function (el) { return !text(el) && !el.querySelector('img,iframe,video,table'); };
  var nextFilled = function (el) {
    var n = el.nextElementSibling;
    while (n && isEmpty(n)) n = n.nextElementSibling;
    return n;
  };
  // Short paragraph whose whole text is bold/underlined, ending in ":" or followed by a list.
  var isHeading = function (el) {
    if (HEAD.test(el.tagName)) return true;
    if (el.tagName !== 'P') return false;
    var t = text(el);
    if (!t || t.length > 60) return false;
    var marked = '';
    el.querySelectorAll('strong,b,u').forEach(function (m) {
      var outer = m.parentElement.closest('strong,b,u');
      if (!outer || !el.contains(outer)) marked += m.textContent; // outermost formatting only
    });
    if (marked.replace(/\s+/g, ' ').trim().length < t.length - 1) return false;
    var nx = nextFilled(el);
    return /:\s*$/.test(t) || !!(nx && LIST.test(nx.tagName));
  };

  var kids = Array.prototype.slice.call(desc.children);
  var intro = [], sections = [], current = null;
  var seenHeading = false;
  // Elements between the <!-- tsp-intro --> and <!-- /tsp-intro --> comments always stay in the open intro.
  var introEls = [], inIntro = false;
  Array.prototype.forEach.call(desc.childNodes, function (n) {
    if (n.nodeType === 8) {
      var v = (n.nodeValue || '').trim();
      if (v === 'tsp-intro') inIntro = true;
      else if (v === '/tsp-intro') inIntro = false;
    } else if (inIntro && n.nodeType === 1) {
      introEls.push(n);
    }
  });
  kids.forEach(function (el) {
    if (introEls.indexOf(el) !== -1) { intro.push(el); return; }
    if (isHeading(el)) {
      seenHeading = true;
      current = { head: el, body: [], heading: HEAD.test(el.tagName), sawList: false };
      sections.push(current);
    } else if (current) {
      // A "Heading:" paragraph owns its list; ordinary text after that list (notes like
      // "IMPORTANT: ...") is not part of the section and stays where it is.
      if (!current.heading && current.sawList && !LIST.test(el.tagName) && !isEmpty(el)) {
        current = null;
        return;
      }
      if (LIST.test(el.tagName)) current.sawList = true;
      current.body.push(el);
    } else if (!seenHeading) {
      intro.push(el);
    }
  });
  sections.forEach(function (s) {
    s.spec = s.heading || s.body.some(function (b) { return LIST.test(b.tagName) || b.querySelector('ul,ol,table'); });
  });
  var specs = sections.filter(function (s) { return s.spec; });
  if (specs.length < 2 || text(desc).length < 600) return;

  var details = document.createElement('details');
  details.className = 'tsp-specs';
  var summary = document.createElement('summary');
  summary.className = 'tsp-specs__summary';
  summary.textContent = 'Full specifications';
  details.appendChild(summary);
  var grid = document.createElement('div');
  grid.className = 'tsp-specs__grid';
  details.appendChild(grid);

  specs.forEach(function (s) {
    var card = document.createElement('div');
    card.className = 'tsp-spec';
    var title = document.createElement('div');
    title.className = 'tsp-spec__title';
    title.textContent = text(s.head).replace(/\s*:\s*$/, '');
    card.appendChild(title);
    s.body.forEach(function (b) { if (!isEmpty(b)) card.appendChild(b); else b.remove(); });
    s.head.remove();
    grid.appendChild(card);
  });

  // Specs panel goes right after the intro; everything else keeps its original order below it.
  var anchor = null;
  for (var i = intro.length - 1; i >= 0; i--) { if (intro[i].parentNode === desc) { anchor = intro[i]; break; } }
  desc.insertBefore(details, anchor ? anchor.nextSibling : desc.firstChild);

  var wide = window.matchMedia('(min-width: 750px)');
  var sync = function () { details.open = wide.matches; };
  sync();
  if (wide.addEventListener) wide.addEventListener('change', sync); else if (wide.addListener) wide.addListener(sync);
})();
